















































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Tabs from '@/components/Tabs.vue';
import moneyTypeList from '@/constants/moneyTypeList';
import dayjs from 'dayjs';
import clone from '@/lib/clone';
import Details from '@/components/Statistics/Details.vue';
import {accAdd, accSub} from '@/lib/operation';

@Component({
    components: {Details, Tabs}
})
export default class Statistics extends Vue {
    moneyType = '-';
    moneyTypeList = moneyTypeList;
    dayjs = dayjs;
    isShowDetails = false;
    selectRecord!: RecordItem;

    get finalNumber() {
        const finalNumber: {
            spend: number;
            income: number;
            total: number;
        } = {spend: 0, income: 0, total: 0};
        for (let i = 0; i < this.recordList.length; i++) {
            const num = this.recordList[i].amount;
            if (this.recordList[i].type === '+') {
                finalNumber.total = accAdd(finalNumber.total, num);
                finalNumber.income = accAdd(finalNumber.income, num);
            } else {
                finalNumber.total = parseFloat(accSub(finalNumber.total, num));
                finalNumber.spend = parseFloat(accSub(finalNumber.spend, num));
            }
        }
        return finalNumber;
    }


    get recordList() {
        return (this.$store.state as RootState).recordList;
    }

    get dataList() {
        const {recordList} = this;
        if (recordList.length === 0) {
            return [] as Result;
        }
        const newList = clone(recordList)
            .filter(r => r.type === this.moneyType)
            .sort((x, y) => dayjs(y.createAt).valueOf() - dayjs(x.createAt).valueOf());

        if (newList.length === 0) {
            return [];
        }
        type Result = {
            title: string;
            total?: number;
            items: RecordItem[];
        }[];
        const result: Result = [{title: dayjs(newList[0].createAt).format('YYYY-MM-DD'), items: [newList[0]]}];
        for (let i = 1; i < newList.length; i++) {
            const current = newList[i];
            const last = result[result.length - 1];
            if (dayjs(last.title).isSame(dayjs(current.createAt), 'day')) {
                last.items.push(current);
            } else {
                result.push({title: dayjs(current.createAt).format('YYYY-MM-DD'), items: [current]});
            }
        }
        result.map(group => {
            group.total = group.items.reduce((sum, item) => accAdd(sum, item.amount), 0);
        });
        return result;
    }

    beforeCreate() {
        this.$store.commit('fetchRecords');
    }

    tagString(tags: Tag[]) {
        return tags.length === 0 ? '无' : tags.map(t => t.name).join('，');
    }

    timeTitle(title: string) {
        const day = dayjs(title);
        const now = dayjs();
        if (day.isSame(now, 'day')) {
            return `${day.format('MM.DD')} 今天`;
        } else if (day.isSame(now.subtract(1, 'day'), 'day')) {
            return `${day.format('MM.DD')} 昨天`;
        } else if (day.isSame(now.subtract(2, 'day'), 'day')) {
            return `${day.format('MM.DD')} 前天`;
        } else if (day.isSame(now, 'year')) {
            return day.format('M月D日');
        } else {
            return day.format('YYYY年M月D日');
        }
    }

    showDetails(item: RecordItem) {
        this.isShowDetails = !this.isShowDetails;
        this.selectRecord = item;
    }

}
